import React, { Children, useEffect, useState, cloneElement } from 'react';
import PropTypes from 'prop-types';

const ComboLinker = ({ children, ...props }) => {
    const [selectedIds, setSelectedIds] = useState([]);
    const [childUpdated, setChildUpdated] = useState();

    const orders = children.map((child) => {
        const tmp = []
        tmp.push(child.props.name)
        return tmp
    });

    const handleChange = (name, ids) => {
        const newSelectedIds = selectedIds;
        newSelectedIds[name] = ids;
        setSelectedIds(newSelectedIds);
        // console.log('newSelectedIds', newSelectedIds);
    };

    useEffect(() => {
        setChildUpdated(false);
    }, [childUpdated]);

    return (
        <div
            {...props}
        >
            {Children.map(children, (child, index) => {
                if (index === 0) {
                    return cloneElement(child, { setState: setChildUpdated, onChange: handleChange })
                } else {
                    return cloneElement(child, { setState: setChildUpdated, onChange: handleChange, parentId: selectedIds[orders[index - 1]] || [] })
                }
            })}

        </div >
    );
};

ComboLinker.propTypes = {
    children: PropTypes.node,
    style: PropTypes.object,
    className: PropTypes.string,
};

export default ComboLinker;
